import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import Routes all
import { publicRoutes, protectedRoutes } from "./routes/allRoutes";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

//api config
import IdleLogout from "./pages/Authentication/IdleLogout";

import { QueryClientProvider } from "react-query";
import { queryClient } from "./lib/react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import ParametersProvider from "./store/GlobalParameters/ParametersProvider";
import ProtectedRoute from "./routes/ProtectedRoute";
import NortiifcationPopup from "./components/Notifications/NotificationPopup";
import NotificationsContextProvider from "./store/Notifications/NotificationsContext";
import { StrictMode } from "react";
import ScrollToTop from "./helpers/ScrollToTop";

const App = () => {
  const envBasename = process.env.REACT_APP_BASENAME;

  return (
    <StrictMode>
      <BrowserRouter basename={envBasename}>
        <ScrollToTop />
        <QueryClientProvider client={queryClient}>
          <ParametersProvider>
            <ReactQueryDevtools />
            <NotificationsContextProvider>
              <NortiifcationPopup />
              
              <Routes>
                {publicRoutes.map((route, idx) => (
                  <Route
                    key={idx}
                    path={route.path}
                    element={
                      <NonAuthLayout>
                        <route.component />
                      </NonAuthLayout>
                    }
                  />
                ))}

                {protectedRoutes.map((route: any, idx: number) => (
                  <Route
                    key={idx}
                    path={route.path}
                    element={
                      <ProtectedRoute isAuthProtected={true}>
                        <VerticalLayout>
                          <route.component />
                        </VerticalLayout>
                      </ProtectedRoute>
                    }
                  />
                ))}
              </Routes>
            </NotificationsContextProvider>
          </ParametersProvider>
          <IdleLogout protectedRoute={true} />
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>
  );
};

export default App;
